import createIcon from '../../createIcon';

/**
 * @component @name LaptopWindows
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTguNVYxNy41QzIxLjEgMTcuNSAyMS45OSAxNi42IDIxLjk5IDE1LjVMMjIgNS41QzIyIDQuNCAyMS4xIDMuNSAyMCAzLjVINEMyLjkgMy41IDIgNC40IDIgNS41VjE1LjVDMiAxNi42IDIuOSAxNy41IDQgMTcuNVYxOC41SDBWMjAuNUgyNFYxOC41SDIwWk00IDUuNUgyMFYxNS41SDRWNS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LaptopWindows = createIcon('LaptopWindows', [
  [
    'path',
    {
      d: 'M20 18.5V17.5C21.1 17.5 21.99 16.6 21.99 15.5L22 5.5C22 4.4 21.1 3.5 20 3.5H4C2.9 3.5 2 4.4 2 5.5V15.5C2 16.6 2.9 17.5 4 17.5V18.5H0V20.5H24V18.5H20ZM4 5.5H20V15.5H4V5.5Z',
      key: 'lkk3k6',
    },
  ],
]);

export default LaptopWindows;
